/**
 * Created by sombra.mac5 on 12/5/16.
 */
angular.module('main').directive('btnSendEmail', () => ({
	restrict: 'AE',
	scope: {
		text: '@snText'
	},
	template:
		'<button class="btn btn-default"><img src="https://app.studioninja.co/build/release-pipeline-119/resources/dist/assets/images/icons/job-email.png" class="fi fi-jobEmail"/>{{text}}</button>',
	replace: true,
	transclude: true,
	link(scope) {
		scope.text = scope.text || 'Send email';
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnSendEmail.js